 <!-- 交易流水 -->
<template>
  <div class="transaction-container">
    <!-- 标题部分 -->
    <div class="header-title">交易流水</div>
    <!-- 查询表单部分 -->
    <el-card shadow="never" class="search-card">
      <el-form :inline="true" :model="filters" size="small" label-width="90px">
        <el-form-item label="交易日期:">
          <el-date-picker
            v-model="filters.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 240px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="账务流水号:">
          <el-input
            v-model="filters.accountFlowNo"
            placeholder="请输入账务流水号"
          ></el-input>
        </el-form-item>
        <el-form-item label="业务流水号:">
          <el-input
            v-model="filters.businessFlowNo"
            placeholder="请输入业务流水号"
          ></el-input>
        </el-form-item>
        <el-form-item label="交易金额:">
          <div class="amount-range">
            <el-input
              v-model="filters.minAmount"
              placeholder="最小值"
            ></el-input>
            <span class="separator">~</span>
            <el-input
              v-model="filters.maxAmount"
              placeholder="最大值"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="商户订单号:">
          <el-input
            v-model="filters.merchantOrderNo"
            placeholder="请输入商户订单号"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否平账:">
          <el-select
            v-model="filters.reconciliationStatus"
            placeholder="请选择"
            style="width: 120px"
          >
            <el-option label="已平账" value="RECONCILED"></el-option>
            <el-option label="未平账" value="UNRECONCILED"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search()">查询</el-button>
          <el-button @click="handleReset()">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 操作按钮组 -->
      <div class="action-buttons">
        <el-button size="small">导入流水</el-button>
        <el-button size="small">导出</el-button>
        <el-button size="small">批量平账</el-button>
      </div>
    </el-card>

    <!-- 表格数据部分 -->
    <el-table
      v-loading="loading"
      :data="transactionFlowList"
      border
      style="width: 100%; margin-top: 20px"
      size="small"
      :header-cell-style="{ background: '#f8f9fa', color: '#606266' }"
    >
      <el-table-column type="selection" align="center" />
      <el-table-column prop="transactionDate" label="交易日期" />
      <el-table-column prop="accountFlowNo" label="账务流水号" />
      <el-table-column prop="businessFlowNo" label="业务流水号" />
      <el-table-column prop="transactionAmount" label="交易金额" />
      <el-table-column prop="fee" label="手续费" />
      <el-table-column prop="settlementAmount" label="清算金额" />
      <el-table-column prop="orderNo" label="商户订单号" />
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="scope">
          <span
            :class="
              scope.row.reconciliationStatus === 'RECONCILED'
                ? 'status-success'
                : 'status-danger'
            "
          >
            {{
              scope.row.reconciliationStatus === "RECONCILED"
                ? "已平账"
                : "未平账"
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="操作人">
        <template slot-scope="scope">
          {{ scope.row.operator || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="reconciliationTime" label="平账时间">
        <template slot-scope="scope">
          {{ _commonFormatter(scope.row, "reconciliationTime") }}
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showDetail(scope.row)">
            查看
          </el-button>
          <!-- v-if="scope.row.reconciliationStatus != 'RECONCILED'" -->
          <el-button
            type="text"
            size="small"
            @click="handleBalance(scope.row)"
            v-if="scope.row.reconciliationStatus != 'RECONCILED'"
          >
            平账
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页部分 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.pageSize"
        layout="total, prev, pager, next, sizes"
        :total="pagination.total"
      >
      </el-pagination>
    </div>

    <!-- ============== 新增：抽屉式弹窗部分 ============== -->
    <el-drawer
      :visible.sync="drawerVisible"
      direction="rtl"
      size="450px"
      :show-close="false"
      class="custom-drawer"
    >
      <!-- 自定义标题：将关闭X放置在左侧 -->
      <template slot="title">
        <div class="drawer-header">
          <i
            class="el-icon-close close-icon"
            @click="drawerVisible = false"
          ></i>
          <span class="drawer-title">流水详情</span>
        </div>
      </template>

      <!-- 抽屉详情主体内容 (使用v-for渲染) -->
      <div class="drawer-content">
        <div class="detail-list">
          <div
            class="detail-item"
            v-for="(item, index) in detailConfig"
            :key="index"
          >
            <!-- 标签 -->
            <div class="detail-label">{{ item.label }}</div>
            <!-- 值 -->
            <div class="detail-value">
              <!-- 对于“平账状态”做特殊高亮处理 -->
              <span v-if="item.key === 'status'" class="status-text-success">
                {{ detailData[item.key] }}
              </span>
              <!-- 普通文本 -->
              <span v-else>{{ detailData[item.key] }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <!-- ============== 新增：流水平账弹窗部分 ============== -->
    <el-dialog
      title="流水平账"
      :visible.sync="balanceDialogVisible"
      width="450px"
      :close-on-click-modal="false"
      class="balance-dialog"
    >
      <el-form
        :model="balanceForm"
        :rules="balanceFormRules"
        ref="balanceForm"
        label-position="top"
        class="balance-form"
      >
        <!-- 使用 v-for 渲染表单项 -->
        <el-form-item
          v-for="(item, index) in balanceFormConfig"
          :key="index"
          :label="item.label"
          :prop="item.prop"
        >
          <el-input
            v-model="balanceForm[item.prop]"
            :disabled="item.disabled"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleBalanceCancel">取消</el-button>
        <el-button type="primary" @click="handleBalanceSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState, mapActions, mapMutations } from "vuex";
import { formatDate } from "../../utils/dateUtil.js";
import { commonFormatter, filterEmptyFields } from "../../utils/tool.js";
import { getCommunityId } from "@/utils/vc.js";

const TAG = "交易流水";

export default {
  data() {
    return {
      // 加载状态
      loading: false,
      // 查询表单变量
      filters: {
        dateRange: "", // 交易日期
        maxAmount: "",
        minAmount: "", // 交易金额
        merchantOrderNo: "", // 商户订单号
        accountFlowNo: "", // 账务流水号
        businessFlowNo: "", // 业务流水号
        reconciliationStatus: "", // 平账状态
      },
      // 分页配置
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 7,
      },

      // ============== 抽屉弹窗专用变量 ==============

      // 控制抽屉显隐
      drawerVisible: false,

      // 当前选中的行，绑定的详情数据
      detailData: {},

      // 详情展示配置字典（严格按照图片文本及顺序遍历）
      detailConfig: [
        { label: "交易日期", key: "transactionDate" },
        { label: "账务流水号", key: "accountFlowNo" },
        { label: "业务流水号", key: "businessFlowNo" },
        { label: "商户订单号", key: "merchantOrderNo" },
        { label: "交易金额", key: "transactionAmount" }, // 带人民币符号
        { label: "手续费", key: "fee" },
        { label: "清算金额", key: "settlementAmount" },
        { label: "平账状态", key: "reconciliationStatus" },
        { label: "操作人", key: "operator" },
        { label: "平账时间", key: "reconciliationTime" },
        { label: "项目名称", key: "projectName" },
        { label: "关联客户名称", key: "customerName" },
        { label: "费用科目", key: "expenseSubject" },
        { label: "计费周期", key: "billingPeriod" },
        { label: "交款人", key: "payer" },
      ],

      // ============== 新增：平账弹窗专用变量 ==============
      // 控制平账弹窗显隐
      balanceDialogVisible: false,

      // 弹窗表单渲染配置(用于v-for)
      balanceFormConfig: [
        { label: "交易金额", prop: "transactionAmount", disabled: true },
        { label: "手续费", prop: "fee", disabled: false },
        { label: "清算金额", prop: "settlementAmount", disabled: false },
      ],

      // 弹窗表单数据绑定
      balanceForm: {
        fee: "", //	手续费
        settlementAmount: "", // 	清算金额
        transactionAmount: "", //交易金额
      },

      // 弹窗表单校验规则
      balanceFormRules: {
        fee: [{ required: true, message: "请输入手续费", trigger: "blur" }],
        settlementAmount: [
          { required: true, message: "请输入清算金额", trigger: "blur" },
        ],
      },
    };
  },

  computed: {
    ...mapState("asset", [
      "transactionFlowList", // 交易流水列表
    ]),
  },

  mounted() {
    this.init();
  },
  methods: {
    ...mapActions("asset", [
      "deleteTransactionFlowHandler", // 删除交易流水处理器
      "getTransactionFlowDetailHandler", // 获取交易流水详情处理器
      "pageTransactionFlowHandler", // 分页获取交易流水列表
      "saveTransactionFlowHandler", // 新增交易流水
      "updateTransactionFlowHandler", // 更新交易流水
      "reconcileHandler", // 平帐操作
    ]),

    // 页面初始化加载
    init() {
      console.log(TAG, "页面加载成功");

      this.search();
    },

    // 搜索
    search() {
      console.log(TAG, "search this.filters", this.filters);
      const params = {};
      const noEmptyFilters = filterEmptyFields({
        startDate: formatDate(_.get(this.filters, "dateRange[0]") || ""), // 交易日期
        endDate: formatDate(_.get(this.filters, "dateRange[1]") || ""), // 交易日期
        minAmount: _.get(this.filters, "minAmount"),
        maxAmount: _.get(this.filters, "maxAmount"),
        merchantOrderNo: _.get(this.filters, "merchantOrderNo"), // 商户订单号
        accountFlowNo: _.get(this.filters, "accountFlowNo"), // 账务流水号
        businessFlowNo: _.get(this.filters, "businessFlowNo"), // 业务流水号
        reconciliationStatus: _.get(this.filters, "reconciliationStatus"), // 平账状态
      });

      Object.assign(params, noEmptyFilters, {
        communityId: getCommunityId(),
        page: this.pagination.currentPage,
        size: this.pagination.pageSize,
      });

      console.log(TAG, "搜索参数 =", params);

      this.pageTransactionFlowHandler(params).then((total) => {
        this.pagination.total = total;
      });
    },

    // 重置表单
    handleReset() {
      this.filters = {
        dateRange: "", // 交易日期
        maxAmount: "",
        minAmount: "", // 交易金额
        merchantOrderNo: "", // 商户订单号
        accountFlowNo: "", // 账务流水号
        businessFlowNo: "", // 业务流水号
        reconciliationStatus: "", // 平账状态
      };

      this.search();
    },
    // 查看详情
    showDetail(row) {
      console.log(TAG, "showDetail enter", row);

      const { id } = row;
      this.getTransactionFlowDetailHandler(id).then((detail) => {
        console.log(TAG, "showDetail detail=", detail);
        this.detailData = {
          ...row,
          ...detail,
          transactionDate: formatDate(_.get(detail, "transactionDate")),
          reconciliationTime: formatDate(_.get(detail, "reconciliationTime")),
        };
        this.openDrawer();
      });
    },
    // 每页条数切换
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.search();
    },
    // 页码切换
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.search();
    },

    // 打开抽屉：查看详情
    openDrawer(row) {
      this.drawerVisible = true;
    },

    // ============== 新增：平账弹窗相关方法 ==============

    // 打开平账弹窗并赋初值
    handleBalance(row) {
      // 从行数据中提取对应字段并赋值给弹窗表单
      this.balanceForm = {
        id: _.get(row, "id") * 1,
        fee: _.get(row, "fee"), //	手续费
        settlementAmount: _.get(row, "settlementAmount"), // 	清算金额
        transactionAmount: _.get(row, "transactionAmount"), //交易金额
      };
      this.balanceDialogVisible = true;

      // 清理上一次可能的验证提示
      this.$nextTick(() => {
        if (this.$refs.balanceForm) {
          this.$refs.balanceForm.clearValidate();
        }
      });
    },

    // 取消平账操作
    handleBalanceCancel() {
      this.balanceDialogVisible = false;
      this.$refs.balanceForm.resetFields();
    },

    clearFomr() {
      this.balanceForm = {
        id: "",
        fee: "", //	手续费
        settlementAmount: "", // 	清算金额
        transactionAmount: "", //交易金额
      };
    },

    // 提交平账操作
    handleBalanceSubmit() {
      this.$refs.balanceForm.validate((valid) => {
        if (valid) {
          const params = filterEmptyFields(this.balanceForm);
          console.log(TAG, "handleBalanceSubmit params=", params);
          this.reconcileHandler(params).then((res) => {
            this.$message.success("平账成功");
            this.balanceDialogVisible = false;
            this.search();
          });
        } else {
          return false;
        }
      });
    },

    _commonFormatter(row, field) {
      return commonFormatter(row, field);
    },
  },
};
</script>

<style lang="scss" scoped>
/* 颜色变量定义 */
$primary-color: #409eff; // 主题蓝
$bg-color: #f0f2f5; // 背景灰
$text-main: #303133; // 主文本色
$text-secondary: #0076fe; // 标题及操作链接色
$success-color: #67c23a; // 已平账绿色
$danger-color: #f56c6c; // 未平账红色
$border-color: #ebeef5; // 边框色

/* ==================== 新增：平账弹窗专用颜色变量 ==================== */
$dialog-title-color: #303133; // 弹窗标题黑
$dialog-label-color: #606266; // 弹窗表单Label灰
$dialog-btn-blue: #1890ff; // 弹窗OK按钮蓝
$dialog-asterisk: #f56c6c; // 必填红星星颜色
$dialog-input-disabled: #f5f7fa; // 禁用输入框背景灰

.transaction-container {
  padding: 20px;
  background-color: #fff;
  min-height: 100vh;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif;

  /* 顶部标题样式 */
  .header-title {
    color: $text-secondary;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 20px;
    position: relative;
    padding-left: 5px;
    text-align: left;
  }

  /* 查询区域卡片 */
  .search-card {
    border: none;
    margin-bottom: 15px;

    ::v-deep .el-card__body {
      padding: 0;
    }
  }

  /* 响应式金额范围输入框样式 */
  .amount-range {
    display: flex;
    align-items: center;
    width: 180px;

    .separator {
      margin: 0 5px;
      color: #909399;
    }

    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }

  /* 按钮组样式 */
  .action-buttons {
    margin: 15px 0;
    text-align: left;
    .el-button {
      background-color: #f5f7fa;
      border: 1px solid #dcdfe6;
      &:hover {
        background-color: $bg-color;
        border-color: #c0c4cc;
      }
    }
  }

  /* 状态标签样式 */
  .status-success {
    color: $success-color;
    background: #f0f9eb;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
  }

  .status-danger {
    color: $danger-color;
    background: #fef0f0;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
  }

  /* 分页容器 */
  .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }

  /* 调整Element默认样式以匹配图片 */
  ::v-deep {
    .el-form-item {
      margin-bottom: 12px;
      margin-right: 20px;
    }
    .el-form-item__label {
      color: $text-main;
      font-weight: normal;
    }
    .el-table {
      border-radius: 4px;
      overflow: hidden;
      th {
        font-weight: 500;
      }
      .el-button--text {
        font-size: 13px;
        color: $text-secondary;
      }
    }
  }
}

.el-form--inline {
  text-align: left;
}
/* 响应式微调 */
@media screen and (max-width: 1400px) {
  .transaction-container {
    .el-form-item {
      margin-right: 10px;
    }
  }
}

/* ==================== 抽屉专用颜色变量 ==================== */
$drawer-border-color: #ebeef5; // 抽屉内部边框线颜色
$drawer-label-text: #606266; // 抽屉详情字典名颜色
$drawer-value-text: #303133; // 抽屉详情字典值颜色
$drawer-status-green: #67c23a; // 抽屉中“已平账”绿色字体(无底色)

/* ==================== 抽屉样式深度覆盖 ==================== */
.custom-drawer {
  ::v-deep .el-drawer__header {
    margin-bottom: 0;
    padding: 15px 20px;
    border-bottom: 1px solid $drawer-border-color;
    color: $drawer-value-text;
    outline: none;
  }

  /* 自定义左侧带X的标题栏 */
  .drawer-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    .close-icon {
      font-size: 18px;
      color: #909399;
      cursor: pointer;
      margin-right: 15px;
      &:hover {
        color: #333;
      }
    }
    .drawer-title {
      font-weight: 500;
    }
  }

  /* 抽屉内容主体 */
  .drawer-content {
    padding: 20px;
    overflow-y: auto;
    height: calc(100vh - 60px);

    /* 仿表格详情列表还原 */
    .detail-list {
      border: 1px solid $drawer-border-color;
      border-bottom: none;
      border-radius: 4px;

      .detail-item {
        display: flex;
        border-bottom: 1px solid $drawer-border-color;
        font-size: 14px;
        min-height: 48px;

        .detail-label {
          width: 140px;
          padding: 12px 15px;
          background-color: #fafafa;
          color: $drawer-label-text;
          display: flex;
          align-items: center;
          border-right: 1px solid $drawer-border-color;
        }

        .detail-value {
          flex: 1;
          padding: 12px 15px;
          color: $drawer-value-text;
          display: flex;
          align-items: center;
          word-break: break-all;

          /* 针对“已平账”的文字进行单独的绿色高亮 */
          .status-text-success {
            color: $drawer-status-green;
          }
        }
      }
    }
  }
}

/* 响应式微调 */
@media screen and (max-width: 1400px) {
  .transaction-container .el-form-item {
    margin-right: 10px;
  }
}

/* ==================== 新增：流水平账弹窗样式 ==================== */
.balance-dialog {
  ::v-deep .el-dialog {
    border-radius: 6px;

    .el-dialog__header {
      padding: 20px 20px 10px;
      text-align: left;
      .el-dialog__title {
        font-size: 16px;
        font-weight: 500;
        color: $dialog-title-color;
      }
    }

    .el-dialog__body {
      padding: 10px 20px 20px;
    }

    .el-dialog__footer {
      padding: 10px 20px 20px;

      .dialog-footer {
        .el-button {
          padding: 9px 20px;
          border-radius: 4px;
        }
        .el-button--primary {
          background-color: $dialog-btn-blue;
          border-color: $dialog-btn-blue;
        }
      }
    }
  }

  /* 弹窗内部表单样式重写 */
  .balance-form {
    ::v-deep .el-form-item {
      margin-bottom: 22px;
      margin-right: 0; /* 覆盖页面级别的设置 */

      /* 让 label 位于输入框顶部 */
      .el-form-item__label {
        line-height: 22px;
        padding-bottom: 8px;
        color: $dialog-label-color;
        text-align: left;
        width: 100%;

        /* 必填星号样式覆盖 */
        &:before {
          color: $dialog-asterisk;
          margin-right: 4px;
        }
      }

      /* 输入框禁用状态颜色覆盖 */
      .el-input.is-disabled .el-input__inner {
        background-color: $dialog-input-disabled;
        color: #909399;
      }
    }
  }
}

/* 响应式微调 */
@media screen and (max-width: 1400px) {
  .transaction-container .el-form-item {
    margin-right: 10px;
  }
}
</style>